import React, {FC, PropsWithChildren} from 'react';
import {ApolloClient, InMemoryCache, ApolloProvider, HttpLink} from '@apollo/client';
import {setContext} from "@apollo/client/link/context";

const httpLink = new HttpLink({uri: '/graphql'});

const authLink = setContext((_, {headers}) => {
    // get the authentication token from local storage if it exists
    const tokenObj = localStorage.getItem('authState');
    let token: string | null = null;
    if (tokenObj) {
        token = JSON.parse(tokenObj).token;
    }
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        }
    }
});

// Initialize Apollo Client
export const gqlClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
        query: {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: "network-only",
        },
        mutate: {
            fetchPolicy: "network-only",
        },
        watchQuery: {
            notifyOnNetworkStatusChange: true,
            fetchPolicy: "network-only",
        }
    }
});

const ApolloProviderWrapper: FC<PropsWithChildren> = ({children}) => {
    return <ApolloProvider client={gqlClient}>
        {children}
    </ApolloProvider>;
}

export default ApolloProviderWrapper;
